<template>
  <div class="relative container">
    <div class="title-lg mg-bt-md">
      <span>操作帮助</span>
    </div>
    <div style="padding: 10px" class="fl-wrap">
      <DataCard download="https://risk-city.oss-cn-hangzhou.aliyuncs.com/risk_qz/file/%E6%B3%89%E5%B7%9E%E5%B8%82%E5%AE%89%E5%85%A8%E7%94%9F%E4%BA%A7%E6%A0%87%E5%87%86%E5%8C%96%E6%99%BA%E6%85%A7%E7%AE%A1%E7%90%86%E5%B9%B3%E5%8F%B0%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%EF%BC%88%E7%9B%91%E7%AE%A1%E7%AB%AF%EF%BC%89202304.pdf" style="width: 250px; margin-right: 25px" title="泉州市安全生产标准化智慧管理平台监管端操作说明书"></DataCard>
      <DataCard download="https://risk-city.oss-cn-hangzhou.aliyuncs.com/risk_qz/doc/20230828%E9%87%8D%E5%A4%A7%E9%9A%90%E6%82%A3%E9%9A%90%E6%82%A3%E6%8E%92%E6%9F%A5%E4%B8%8A%E6%8A%A5%E6%91%98%E7%89%8C%E9%94%80%E6%A1%88%E6%93%8D%E4%BD%9C%E8%AF%B4%E6%98%8E%E4%B9%A6(2).pdf" style="width: 250px; margin-right: 25px" title="泉州市安全生产标准化智慧管理平台重大隐患自查上报摘牌销案操作说明书"></DataCard>
      <DataCard type="video" download="https://risk-city.oss-cn-hangzhou.aliyuncs.com/risk_qz/doc/20231010%E5%8A%A0%E5%BC%BA%E5%AE%89%E5%85%A8%E7%94%9F%E4%BA%A7%E6%A0%87%E5%87%86%E5%8C%96%E5%BB%BA%E8%AE%BE%E6%8E%A8%E8%BF%9B%E4%BC%81%E4%B8%9A%E4%B8%BB%E4%BD%93%E8%B4%A3%E4%BB%BB%E8%90%BD%E5%88%B0%E5%AE%9E%E5%A4%84.mp4" style="width: 250px; margin-right: 25px" title="20230707加强安全生产标准化建设推进企业主体责任落到实处"></DataCard>
      <DataCard download="https://risk-city.oss-cn-hangzhou.aliyuncs.com/risk_qz/doc/20240305%E4%BC%81%E4%B8%9A%E5%9F%BA%E6%9C%AC%E4%BF%A1%E6%81%AF%E5%A4%8D%E6%A0%B8%E6%93%8D%E4%BD%9C%E8%AF%B4%E6%98%8E%E4%B9%A6.pdf" style="width: 250px; margin-right: 25px" title="20240305企业基本信息复核操作说明书"></DataCard>
      <DataCard download="https://risk-city.oss-cn-hangzhou.aliyuncs.com/risk_qz/docx/%E4%B9%9D%E5%B0%8F%E5%9C%BA%E6%89%80%E5%AE%89%E5%85%A8%E7%94%9F%E4%BA%A7%E6%A0%87%E5%87%86%E5%8C%96%E7%AE%A1%E7%90%86%E5%B9%B3%E5%8F%B0%E6%93%8D%E4%BD%9C%E8%AF%B4%E6%98%8E%E4%B9%A620240909.rar" style="width: 250px; margin-right: 25px" title="20240909九小场所安全生产标准化管理平台操作说明书"></DataCard>
    </div>
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="visible" class="input_video">
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions">
      </video-player>
    </el-dialog>
  </div>
</template>

<script>
import DataCard from '@/Util/DataCard'
export default {
  components: {
    DataCard
  },
  data() {
    return {
      title: '',
      visible: false,
      playerOptions: {
        language: 'zh-CN',
        playbackRates: [ 0.5, 1.0, 1.5, 2.0 ], // 可选择的播放速度
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: '',
          src: '' // url地址
        }]
      }
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    showVideo (src, title) {
      this.visible = true
      // this.playerOptions.sources[0].src = src
      // this.title = title
      this.$nextTick(() => {
        this.$refs.videoPlayer.player.src(src)
        this.$refs.videoPlayer.player.reset()
        this.title = title
      })
    }
  }
}
</script>

<style scoped>
  .close {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 32px;
    cursor: pointer;
    color: grey;
  }
</style>



// WEBPACK FOOTER //
// src/views/systemData/systemData.vue